import { safelyGetItem } from 'utils/localStorage';
import { ESupportedLocales } from './localization.enums';
import {
  getLocaleByStoredLocaleData,
  getUserLocaleVocabularyByLocale,
} from './localization.utils';

export const getLocalizationInitialState = () => {
  const storedLocale = safelyGetItem(LOCALE_LOCAL_STORAGE_KEY);
  const initialLocale = getLocaleByStoredLocaleData(storedLocale);

  return {
    data: {
      locale: initialLocale,
      translations: getUserLocaleVocabularyByLocale(
        initialLocale as ESupportedLocales
      ),
    },
    isLoading: false,
    error: null,
  };
};

export const localeSelectOptions = [
  {
    id: ESupportedLocales.EN,
    label: 'EN',
    value: ESupportedLocales.EN,
  },
  {
    id: ESupportedLocales.PL,
    label: 'PL',
    value: ESupportedLocales.PL,
  },
  {
    id: ESupportedLocales.UK,
    label: 'UA',
    value: ESupportedLocales.UK,
  },
];

export const LOCALE_LOCAL_STORAGE_KEY = 'locale';
